import { useSelector } from 'react-redux'
import { ApplicationStateT } from '../../types/applicationState'
import { SessionStateT } from '../../types/session'

function useSession(): SessionStateT {
  return useSelector<ApplicationStateT, SessionStateT>(({ session }) => session)
}

export default useSession
